import { render } from "./BookedLeads.vue?vue&type=template&id=15854f2e"
import script from "./BookedLeads.vue?vue&type=script&lang=js"
export * from "./BookedLeads.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__